import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './deviceDetail2.module.scss';
import SVG from 'react-inlinesvg';
import { launchSVG } from '../../../shared/helpers/icons';
import { toast } from '../../../shared/helpers/toast';
import Tooltip from '@material-ui/core/Tooltip';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '../../../shared/components/Button';
import ModalResetDevice from './ModalResetDevice';


const DeviceDetail = ({ devices: { device, statuses, history: historyDevices, historyFetching, substatuses = [], substatusesFetching = false, devices: devicesArray = []}, getDevicesStatusesRequest, getHistoryDevicesRequest, getGpsDevicesRequest, gps, getDevicesSubstatusesRequest, patchDevicesRequest, getDevicesRequest, setDeviceSelected }) => {
    const [pendingImei, setPendingImei] = useState(null);
    const [resetModalOpen, setResetModalOpen] = useState(false);
    const history = useHistory();
    const location = useLocation();
    
    const handleGotoGps = (imei, e) => {
        e.stopPropagation();
        setPendingImei(imei);
        getGpsDevicesRequest({
            search: imei,
            full_simcards: 1,
            full_status: 1,
            full_devices: 1,
            full_assigned: 1,
            full_company: 1,
            limit: 50,
            page: 1
        });
    };
    
    const handleBack = () => {
        if (location.state && location.state.from) {
            history.push(location.state.from);
        } else {
            history.goBack();
        }
    };
    const { imei } = useParams();
    const { t } = useTranslation(['home', 'devices']);

    useEffect(() => {
        getDevicesStatusesRequest();
    }, [getDevicesStatusesRequest]);

    useEffect(() => {
        if (imei) {
            getHistoryDevicesRequest({ imei });
        }
    }, [getHistoryDevicesRequest, imei]);

    // Actualizar el dispositivo seleccionado cuando el array de devices cambie
    useEffect(() => {
        if (devicesArray && devicesArray.length > 0 && imei) {
            const updatedDevice = devicesArray.find(d => d.imei === imei);
            if (updatedDevice && updatedDevice._id === device?._id) {
                setDeviceSelected(updatedDevice);
                // Recargar el historial también
                getHistoryDevicesRequest({ imei });
            }
        }
    }, [devicesArray, imei, device?._id, setDeviceSelected, getHistoryDevicesRequest]);

    useEffect(() => {
        if (
            pendingImei &&
            gps &&
            Array.isArray(gps.gps_devices)
        ) {
            if (gps.gps_devices.length === 0) {
                toast('Intente nuevamente', 'gps-not-found');
                setPendingImei(null);
                return;
            }
            const gpsFound = gps.gps_devices.find(
                g => g.device && g.device.imei === pendingImei
            );
            if (gpsFound && gpsFound.name) {
                history.push(`/stock/gps/${gpsFound.name}`);
                setPendingImei(null);
            } else {
                const imei = pendingImei || '';
                const last8 = imei.slice(-8);
                history.push(`/stock/gps/${last8}`);
                setPendingImei(null);
            }
        }
    }, [gps, pendingImei, history]);



    if (!device) {
        return <div className={styles.loading}>Cargando...</div>;
    }

    function formatDate(fecha) {
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
        const anio = date.getFullYear();
        return `${dia}-${mes}-${anio}`;
      }

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.titleContainer}>
                    <h3 className={styles.title}>Detalles del Dispositivo</h3>
                </div>
                {device.status_name !== 'Asignado a GPS' && device.status_name !== 'Bodega' && (
                    <div className={styles.buttonsContainer}>
                        <Button className={styles.buttonReset} onClick={() => setResetModalOpen(true)}>
                            Resetear
                        </Button>
                    </div>
                )}
            </div>
            <ModalResetDevice
                open={resetModalOpen}
                onClose={() => setResetModalOpen(false)}
                device={device}
                getDevicesSubstatusesRequest={getDevicesSubstatusesRequest}
                substatuses={substatuses}
                fetchingSubstatuses={substatusesFetching}
                patchDevicesRequest={patchDevicesRequest}
                getDevicesRequest={getDevicesRequest}
                setDeviceSelected={setDeviceSelected}
                imei={imei}
            />
            <div className={styles.section}>
                <div className={styles.tableContainer}>
                <table className={styles.gpsTable}>
                <thead className={styles.headerTable}>
                        <tr>
                            
                            <th className={styles.colImei}>IMEI</th>
                            <th className={styles.colProvider}>{t('devices:provider')}</th>
                            <th className={styles.colModel}>{t('devices:model')}</th>
                            <th className={styles.colStatus}>{t('home:status')}</th>
                            <th className={styles.colSubstatus}></th>
                            <th className={styles.colDate}>{t('devices:admission_date')}</th>
                            <th className={styles.colEnabled}>{t('devices:enabled')}</th>
                            <th className={styles.colGps}></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            
                            <td>{device.imei}</td>
                            <td>{device.provider}</td>
                            <td>{device.model_name}</td>
                            <td className={styles.statusCell}>
                                {device.status_name && device.status_name !== '-' ? (
                                    <>
                                        <div className={`${styles.status} ${styles[device.status_name?.toLowerCase().replace(/\s+/g, '-')] || ''}`}>
                                            {device.status_name}
                                        </div>
                                        {device.status_name !== 'Baja' && <span className={styles.arrow}>›</span>}
                                    </>
                                ) : '-'}
                            </td>
                            <td>
                                {device.status_name && device.status_name !== 'Baja' ? (
                                    device.substatus?.value ? (
                                        <div className={`${styles.status} ${styles[device.status_name?.toLowerCase().replace(/\s+/g, '-')] || ''}`}>
                                            {device.substatus.value}
                                        </div>
                                    ) : '-'
                                ) : '-'}
                            </td>
                            <td>{formatDate(device.created)}</td>
                            <td style={{ textAlign: 'center' }}>
                                <SVG
                                    src={device.enabledIcon}
                                    className={`${styles.svg} ${device.enabled ? styles.enabled : styles.disabled}`}
                                />
                            </td>
                            <td className={styles.iconColumn}>
                                {device.status_name === "Asignado a GPS" ? (
                                    <Tooltip title="Ver GPS asignado" placement="bottom">
                                        <div 
                                            onClick={(e) => handleGotoGps(device.imei, e)}
                                            className={styles.launchIconWrapper}
                                        >
                                            <SVG
                                                src={launchSVG}
                                                className={styles.launchIcon}
                                            />
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <div></div>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
               
            </div>
            <div className={styles.section}>
                <h3 className={styles.subtitle}>Historial de movimientos</h3>
                <div className={`${styles.tableContainer} ${styles.withScroll}`}>
                    <table className={styles.gpsTable}>
                        <thead>
                            <tr>
                                <th className={styles.colFecha}>Fecha</th>
                                <th className={styles.colResponsable}>Responsable</th>
                                <th className={styles.colAccion}>Acción</th>
                                <th className={styles.colEstado}>De</th>
                                <th className={styles.colSubEstado}>A</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historyFetching ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>Cargando...</td>
                                </tr>
                            ) : (!historyDevices || historyDevices.length === 0) ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>No se han realizado movimientos</td>
                                </tr>
                            ) : (
                                historyDevices.map((movement, index) => (
                                    <tr key={index}>
                                        <td>{new Date(movement.date).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</td>
                                        <td>{movement.responsible}</td>
                                        <td>{movement.action}</td>
                                        <td className={styles.statusCell} style={{ position: 'relative' }}>
                        {movement.previousData &&
                        typeof movement.previousData === 'string' &&
                        movement.previousData.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === 'no asignado' ? (
                            <div>-</div>
                        ) : movement.previousData ? (
                            <div className={`${styles.status} ${styles[(typeof movement.previousData === 'string' ? movement.previousData : '').toLowerCase().replace(/\s+/g, '-')] || ''}`}>
                                {movement.previousData}
                            </div>
                        ) : (
                            <div>-</div>
                        )}
                        <span 
                            className={styles.arrow} 
                            style={{ 
                                position: 'absolute', 
                                right: '45px', 
                                visibility:
                                    movement.previousData &&
                                    typeof movement.previousData === 'string' &&
                                    movement.previousData.toLowerCase() !== 'baja'
                                        ? 'visible'
                                        : 'hidden'
                            }}
                        >›</span>
                    </td>
                    <td>
                        {movement.newData &&
                        typeof movement.newData === 'string' &&
                        movement.newData.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === 'no asignado' ? (
                            <div>-</div>
                        ) : movement.newData ? (
                            <div className={`${styles.status} ${styles[(typeof movement.newData === 'string' ? movement.newData : '').toLowerCase().replace(/\s+/g, '-')] || ''}`}>
                                {movement.newData}
                            </div>
                        ) : (
                            <div>-</div>
                        )}
                    </td>

                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                </div>
        </div>
    );
};

export default DeviceDetail;
